"use client";

import { useEffect, useState } from "react";
import style from "./style.module.scss";
import Image from "next/image";
import { APP_STORE_URL, GOOGLE_PLAY_URL, APP_STORE } from "@/constants";
import useQrPopupContext from "@/contexts/qr-popup-context";
import { WINDOW_BREAKPOINTS } from "@/constants/global";
import { openExternalLink } from "@/helpers/security-helpers";

const Markets = ({ height }: { height: number }) => {
  const { openQrPopup } = useQrPopupContext();
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkWindowSize = () => {
      setIsDesktop(window.innerWidth > WINDOW_BREAKPOINTS.tablet);
    };

    checkWindowSize();
  }, []);

  const handleAppStoreClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (isDesktop) {
      openQrPopup("app-store");
    } else {
      openExternalLink(APP_STORE_URL);
    }
  };

  const handleGooglePlayClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (isDesktop) {
      openQrPopup("google-play");
    } else {
      openExternalLink(GOOGLE_PLAY_URL);
    }
  };

  return (
    <div className={style.getAppMarkets}>
      <Image
        className={style.marketImage}
        src="/icon/markets/app-store.svg"
        alt="App Store"
        width={0}
        height={height}
        onClick={handleAppStoreClick}
      />
      <Image
        className={style.marketImage}
        src="/icon/markets/google-play.svg"
        alt="Google Play"
        width={0}
        height={height}
        onClick={handleGooglePlayClick}
      />
    </div>
  );
};

export default Markets;
